export default "__VITE_ASSET__B$e4OJuf__"